import { useTranslation } from "react-i18next";
import styles from "./InputSearch.module.scss";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import Search from "@mui/icons-material/Search";
import { useState } from "react";

interface Props {
  placeholder: string;
  onSearch: (value: string) => void;
  onChange: (value: string) => void;
  valueDefault?: string;
}

const InputSearch: React.FC<Props> = ({
  placeholder,
  onSearch,
  onChange,
  valueDefault,
}) => {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState<string>(valueDefault ?? "");

  const handleKey = (e: any) => {
    if (e.key === "Enter") {
      onSearch(currentValue);
    }
  };

  const handleClick = (e: any) => {
    onSearch(currentValue);
  };

  return (
    <TextField
      placeholder={t(placeholder) || ""}
      className={styles.text}
      value={currentValue}
      onKeyUp={handleKey}
      fullWidth
      onChange={(event) => {
        setCurrentValue(event.currentTarget.value);
        onChange(event.currentTarget.value);
      }}
      InputProps={{
        startAdornment: (
          <IconButton onClick={handleClick} className={styles.searchIcon}>
            <Search />
          </IconButton>
        ),
      }}
    />
  );
};

export default InputSearch;
